import React, { SVGProps } from 'react';

export const ClosedBookSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M3.90006 4.4575V12.6575C3.89958 12.8371 3.93861 13.0146 4.0144 13.1775C4.09018 13.3403 4.20085 13.4845 4.33857 13.5997C4.47629 13.715 4.63768 13.7986 4.81131 13.8446C4.98494 13.8905 5.16655 13.8977 5.34326 13.8656L10.4874 12.9472C10.9406 12.8673 11.3509 12.6299 11.646 12.2768C11.9411 11.9237 12.1019 11.4777 12.1001 11.0175V5.26657C12.0989 5.16592 12.0755 5.06678 12.0315 4.97623C11.9876 4.88568 11.9242 4.80596 11.8458 4.74276C11.7675 4.67957 11.6761 4.63446 11.5783 4.61066C11.4805 4.58686 11.3787 4.58497 11.2801 4.6051L5.3378 5.69844C5.01665 5.75643 4.68563 5.68448 4.41754 5.4984C4.14945 5.31233 3.96626 5.02738 3.90826 4.70624C3.85027 4.3851 3.92222 4.05407 4.1083 3.78598C4.29437 3.51789 4.57932 3.3347 4.90046 3.2767L11.2801 2.1123'
      stroke='currentColor'
      strokeWidth='0.88'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.3892 2.26562L11.559 4.61083'
      stroke='currentColor'
      strokeWidth='0.88'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
